import { useImperativeHandle, forwardRef, useState } from 'react';

import { NavLink } from 'react-router-dom';

import classNames from 'classnames';

import { CrossIcon } from '../../icons';

import Portal from '../../portal/Portal';

import useNavigation from '../../../hooks/useNavigation';
import useCategories from '../../../hooks/useCategories';

import MobileMenuItem from './MobileMenuItem';

import classes from './MobileMenu.module.css';

const MobileMenu = (props, ref) => {
    const [open, setOpen] = useState(false);
    const [closing, setClosing] = useState(false);

    const top = useNavigation('bottom');
    const bottom = useNavigation('top');
    const { categories } = useCategories();


    useImperativeHandle(ref, () => ({
        openMenu: () => { setOpen(true); }
    }));

    const onAnimationEnd = () => {
        if (closing) {
            setOpen(false);
            setClosing(false);
        }
    }

    return (
        <Portal>
            {
                open
                &&
                <div
                    className={classNames(classes.container, (closing && classes.closing))}
                    onClick={() => { setClosing(true); }}
                    onAnimationEnd={onAnimationEnd}
                >
                    <aside className={classes.aside} onClick={(event) => event.stopPropagation()}>
                        <div className={classes.header}>
                            <div className={classes.close} onClick={() => { setClosing(true); }}>
                                <CrossIcon />
                            </div>
                            <span className={classes.heading}>MENU</span>
                        </div>

                        <div className={classes.overflow}>

                            <nav className={classes.menu}>
                                
                                {              
                                    categories !== null && categories.map(({ key, name, parent_category, categories=[] }) => {
                                        if (!parent_category) {
                                            return (
                                                <MobileMenuItem key={key} item={{ key, name, categories }} setClosing={setClosing} />
                                            )
                                        } else {
                                            return null;
                                        }
                                    })
                                }

                                {
                                    top.map(({ nav_name, url_key, type }) => {
                                        if (type === 'external') {
                                            return <a key={url_key} href={url_key}>{nav_name}</a>
                                        } else {
                                            return <NavLink key={url_key} to={'/' + url_key}>{nav_name}</NavLink>
                                        }
                                    })
                                }

                            </nav>

                            <nav className={classes.bottommenu}>
                                {
                                    bottom.map(({ nav_name, url_key, type }) => {
                                        if (type === 'external') {
                                            return <a key={url_key} href={url_key}>{nav_name}</a>
                                        } else {
                                            return <NavLink key={url_key} to={'/' + url_key}>{nav_name}</NavLink>
                                        }
                                    })
                                }
                            </nav>

                        </div>
                    </aside>
                </div>
            }

        </Portal>
    );
}

export default forwardRef(MobileMenu);